import { Typography, Box } from "@mui/material";
import ModalGeneric from "../Generics/ModalGeneric";
import { useState } from "react";
import { Paper, Theme } from "@material-ui/core";
import { DadosSolicitacaoEmissao } from "../../model/entities/SolicitacaoEmissaoCTe";
import React from "react";
import Tabs from "@material-ui/core/Tabs";
import Tab from "@material-ui/core/Tab";
import InformacoesCTe from "../../pages/SolicitacaoCTe/InformacoesCTe";
import { Assignment, LocalShipping } from "@mui/icons-material";
import InformacoesDescarregamento from "../../pages/SolicitacaoCTe/InformacoesDescarregamento";

type Props = {
  open: boolean;
  onClose: () => void;
  solicitacao: DadosSolicitacaoEmissao;
};

const ModalSolicitacaoEmissaoCTe: React.FC<Props> = (props) => {
  const { open, onClose, solicitacao } = props;

  interface TabPanelProps {
    children?: React.ReactNode;
    index: any;
    value: any;
  }

  function TabPanel(props: TabPanelProps) {
    const { children, value, index, ...other } = props;

    return (
      <div
        role="tabpanel"
        hidden={value !== index}
        id={`simple-tabpanel-${index}`}
        aria-labelledby={`simple-tab-${index}`}
        {...other}
      >
        {value === index && (
          <Box p={3}>
            <Typography>{children}</Typography>
          </Box>
        )}
      </div>
    );
  }

  const [value, setValue] = useState(0);

  const handleChange = (event: React.ChangeEvent<{}>, newValue: number) => {
    setValue(newValue);
  };

  return (
    <ModalGeneric open={open} onClose={onClose} hideCloseBootom>
      <Paper>
        <Tabs
          value={value}
          onChange={handleChange}
          textColor="primary"
          indicatorColor="primary"
          centered
          variant="fullWidth"
          style={{
            borderBottom: "2px solid #ccc",
          }}
        >
          <Tab
            icon={<Assignment />}
            label="Informações emissão CTe"
            style={{
              fontWeight: "bold",
              fontSize: "16px",
              backgroundColor: value === 0 ? "#fff" : "transparent",
              borderTopLeftRadius: "8px",
              borderTopRightRadius: "8px",
              border: value === 0 ? "1px solid #ccc" : "none",
              borderBottom: value === 0 ? "none" : "1px solid #ccc",
            }}
          />
          <Tab
            icon={<LocalShipping />}
            label="Informações descarregamento"
            style={{
              fontWeight: "bold",
              fontSize: "16px",
              backgroundColor: value === 1 ? "#fff" : "transparent",
              borderTopLeftRadius: "8px",
              borderTopRightRadius: "8px",
              border: value === 1 ? "1px solid #ccc" : "none",
              borderBottom: value === 1 ? "none" : "1px solid #ccc",
            }}
          />
        </Tabs>
      </Paper>

      <TabPanel value={value} index={0}>
        <InformacoesCTe solicitacao={solicitacao} />
      </TabPanel>

      <TabPanel value={value} index={1}>
        <InformacoesDescarregamento solicitacao={solicitacao} />
      </TabPanel>
    </ModalGeneric>
  );
};

export default ModalSolicitacaoEmissaoCTe;
